import {
  Configuration,
  AgenciesApi,
  AgencyGroupsApi,
  AppointmentsApi,
  DashboardApi,
  ImportsApi,
  LeadsApi,
  PacsApi,
  TaskResultsApi,
  UsersApi,
} from "@socotec.io/vigico-back-sdk";
import { useOidcStore } from "vue3-oidc";

const configuration = new Configuration({
  basePath: import.meta.env.VITE_APP_BACK_URL,
  accessToken: () => useOidcStore().state.value.token,
});

export const useAgenciesApi = () => new AgenciesApi(configuration);
export const useAgencyGroupsApi = () => new AgencyGroupsApi(configuration);
export const useDashboardApi = () => new DashboardApi(configuration);
export const useLeadsApi = () => new LeadsApi(configuration);
export const usePacsApi = () => new PacsApi(configuration);
export const useAppointmentsApi = () => new AppointmentsApi(configuration);
export const useImportsApi = () => new ImportsApi(configuration);
export const useTaskResultsApi = () => new TaskResultsApi(configuration);
export const useUsersApi = () => new UsersApi(configuration);
